module.exports = __webpack_public_path__ + "static/media/top_infographic.1b4e6781.webp";